import {styled} from '@mui/material'
import {Images, Texts} from 'appearance'
import FormSelect from 'components/Control/Form/FormSelect'
import FormTextInput from 'components/Control/Form/FormTextInput'
import {genderKod, occupations} from 'constants/users'
import {useFormContext} from 'react-hook-form'
import {useI18n} from 'store/Store'
import WizardComponentWrapper from '../WizardComponentWrapper'
import {registerUserDetailsSchema} from 'services/utils/validationsSchemas'
import {useYupValidation} from 'services/hooks'
import {useEffect} from 'react'
import analyticsService from 'services/analytic'
import ApproveTerms from 'components/Control/ApproveTerms'

const UserDetails = ({setValidationError}) => {
    const {i18n} = useI18n()
    const formContext = useFormContext()

    const {
        control: formControl,
        formState: {errors: formErrors},
        watch,
        getValues,
        setValue,
    } = formContext

    const id = watch('id')
    const approvedTermsValue = watch('approvedTerms')
    const gender = watch('GenderKod')

    useEffect(() => {
        if (gender === genderKod[1]) {
            analyticsService.onboardingPressedFemale()
        } else if (gender === genderKod[2]) {
            analyticsService.onboardingPressedMale()
        }
    }, [gender])

    useYupValidation(
        registerUserDetailsSchema,
        getValues,
        [id, approvedTermsValue],
        setValidationError
    )

    return (
        <WizardComponentWrapper sideImage={Images.REGISTER_STEP_4}>
            <Text>{i18n.t('register.personalDetailsTitle')}</Text>

            <FormSelect
                orientation="vertical"
                itemName="users"
                name="Profession"
                placeholder={'gsfdgdf'}
                label={i18n.t('clients.Profession')}
                formControl={formControl}
                formErrors={formErrors}
                options={occupations}
                height="48px"
                style={{color: '#95969A', width: '100%', marginBottom: 10}}
                selectStyle={{
                    background: '#FAFAFA',
                    borderRadius: 6,
                }}
                labelFontSize={18}
            />

            <FormTextInput
                name="id"
                label={i18n.t('users.id')}
                control={formControl}
                rules={{
                    required: true,
                }}
                fullWidth
                initialValue=""
                errors={formErrors}
                height="48px"
                style={{color: '#95969A', marginBottom: 10}}
                InputProps={{style: {background: '#FAFAFA'}}}
            />

            <FormSelect
                orientation="vertical"
                itemName="users"
                name="GenderKod"
                label={i18n.t('clients.GenderKod')}
                control={formControl}
                formErrors={formErrors}
                options={Object.values(genderKod)}
                height="48px"
                style={{color: '#95969A', width: '100%', marginBottom: 10}}
                selectStyle={{
                    background: '#FAFAFA',
                    borderRadius: 6,
                }}
                labelFontSize={18}
            />

            <ApproveTerms
                control={formControl}
                checkboxProps={{
                    checked: getValues()?.approvedTerms,
                    onChange: (e) =>
                        setValue('approvedTerms', e.target.checked),
                }}
            />
        </WizardComponentWrapper>
    )
}

export default UserDetails

const Text = styled(Texts.BoldText)`
    font-size: 24px;
    text-align: right;
    width: 100%;
`
